import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {StorageProvider} from './storage';
import {NavParamService} from './navparams';
import {Router} from '@angular/router';
import {User} from './db/User';
import {ApiCall} from '../utils/api/apicall';
import {ApiJsonResult} from '../utils/api/apijsonresult';
import {Tracker} from './db/Tracker';
import {Child} from './db/Child';
import {OnlinePayment} from './db/OnlinePayment';
import {BaseProvider} from './base';

@Injectable({
  providedIn: 'root'
})
export class AuthService extends BaseProvider {

  constructor(public http: HttpClient, public storage: StorageProvider, public navService: NavParamService, public router: Router) {
    super(http, storage, navService, router);
  }

  login(input: User) {
    const apiCall = ApiCall.postjson('scopev2', '/user/login', JSON.stringify(input));
    return new Promise((resolve, reject) => {
      super.callapi(apiCall).then((apijsonResult: ApiJsonResult) => {
        const tracker = Tracker.apimapper(apijsonResult);
        this.storage.storeToken(tracker.uid).then(() => {
          resolve(tracker);
        });
      }, (err) => {
        reject(err);
      });
    });
  }

  signup(input: User) {
    const apiCall = ApiCall.postjson('scopev2', '/user/signup', JSON.stringify(input));
    return new Promise((resolve, reject) => {
      super.callapi(apiCall).then((apijsonResult: ApiJsonResult) => {
        const tracker = Tracker.apimapper(apijsonResult);
        this.storage.storeToken(tracker.uid).then(() => {
          resolve(tracker);
        });
      }, (err) => {
        reject(err);
      });
    });
  }

  childById(childId: any) {
    const apiCall = ApiCall.getter('scopev2', '/user/child/byid/' + childId);
    return new Promise((resolve, reject) => {
      super.callapi(apiCall).then((apijsonResult: ApiJsonResult) => {
        const single = Child.apimapper(apijsonResult);
        resolve(single);
      }, (err) => {
        reject(err);
      });
    });
  }

  childrenList() {
    const apiCall = ApiCall.getter('scopev2', '/user/child/list');
    return new Promise((resolve, reject) => {
      super.callapi(apiCall).then((apijsonResult: ApiJsonResult) => {
        const lst = Child.apimapperLst(apijsonResult);
        resolve(lst);
      }, (err) => {
        reject(err);
      });
    });
  }

  childSave(input: Child) {
    const apiCall = ApiCall.postjson('scopev2', '/user/child', JSON.stringify(input));
    return new Promise((resolve, reject) => {
      super.callapi(apiCall).then((apijsonResult: ApiJsonResult) => {
        const child = Child.apimapper(apijsonResult);
        resolve(child);
      }, (err) => {
        reject(err);
      });
    });
  }

  childActivate(payment: OnlinePayment) {
    const apiCall = ApiCall.postjson('scopev2', '/user/child/activate', JSON.stringify(payment));
    return new Promise((resolve, reject) => {
      super.callapi(apiCall).then((apijsonResult: ApiJsonResult) => {
        const child = Child.apimapper(apijsonResult);
        resolve(child);
      }, (err) => {
        reject(err);
      });
    });
  }

  childDelete(childId: any) {
    const apiCall = ApiCall.getter('scopev2', '/user/child/delete/' + childId);
    return new Promise((resolve, reject) => {
      super.callapi(apiCall).then((apijsonResult: ApiJsonResult) => {
        resolve('Ok');
      }, (err) => {
        reject(err);
      });
    });
  }

  user() {
    const apiCall = ApiCall.getter('scopev2', '/user/user');
    return new Promise((resolve, reject) => {
      super.callapi(apiCall).then((apijsonResult: ApiJsonResult) => {
        const single = User.apimapper(apijsonResult);
        resolve(single);
      }, (err) => {
        reject(err);
      });
    });
  }

    forgotPassword(emailAddress: string) {
      const apiCall = ApiCall.getter('scopev2', '/user/forgotpassword/' + emailAddress);
      return new Promise((resolve, reject) => {
        super.callapi(apiCall).then((apijsonResult: ApiJsonResult) => {
          const single = User.apimapper(apijsonResult);
          resolve(single);
        }, (err) => {
          reject(err);
        });
      });
    }

    resetPassword(email: string, otp: string, password: any) {
      const apiCall = ApiCall.getter('scopev2', '/user/resetpassword/' + email + '/' + otp + '/' + password);
      return new Promise((resolve, reject) => {
        super.callapi(apiCall).then((apijsonResult: ApiJsonResult) => {
          const tracker = Tracker.apimapper(apijsonResult);
          this.storage.storeToken(tracker.uid).then(() => {
            resolve(tracker);
          });
        }, (err) => {
          reject(err);
        });
      });
    }
}
